module.exports = __webpack_public_path__ + "klinika.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/doctors/klinika.png
// module id = 897
// module chunks = 0